import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {NdfListItemComponent} from "../../../ndf/ndf-list/ndf-list-item/ndf-list-item.component";
import {Store} from "@ngrx/store";
import {AppState} from "@domain/appstate";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";

/**
 * Item de la liste des NDF du Dashboard
 */
@Component({
    selector: 'dashboard-ndf-list-item',
    templateUrl: './dashboard-ndf-list-item.component.html'
})
export class DashboardNdfListItemComponent extends NdfListItemComponent {

    /**
     * Constructeur
     *
     * @param router le routeur
     * @param store le store
     * @param matDialog le composant des popups
     */
    constructor(protected router: Router,
                protected store: Store<AppState>,
                protected matDialog: MatDialog) {
        super(router, store, matDialog);
    }
}
